import { render, staticRenderFns } from "./ReporteStockShow.vue?vue&type=template&id=1b1ef176"
import script from "./ReporteStockShow.vue?vue&type=script&lang=js"
export * from "./ReporteStockShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports